import {gql} from "graphql-tag";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const statisticSiteCategoryFields = `
id
uniqueId
title
sites {
  id
  uniqueId
  title
  url
}
`;


export const CREATE_STATISTIC_SITE_CATEGORY_MUTATION = gql`
mutation CreateStatisticSiteCategoryMutation($input: StatisticSiteCategoryInputObject!) {
  createStatisticSiteCategoryMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${statisticSiteCategoryFields}
    }
  }
}
`


export const UPDATE_STATISTIC_SITE_CATEGORY_MUTATION = gql`
mutation UpdateStatisticSiteCategoryMutation($input: StatisticSiteCategoryInputObject!) {
  updateStatisticSiteCategoryMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${statisticSiteCategoryFields}
    }
  }
}
`


export const DELETE_STATISTIC_SITE_CATEGORY_MUTATION = gql`
mutation DeleteStatisticSiteCategoryMutation($uniqueId: String!) {
  deleteStatisticSiteCategoryMutation(uniqueId: $uniqueId) {
    ${baseResponseGraphqlField}
  }
}
`


export const GET_STATISTIC_SITE_CATEGORIES = gql`
query GetStatisticsSiteCategories($filtering: StatisticSiteCategoryFilteringInputObject) {
  getStatisticsSiteCategories(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${statisticSiteCategoryFields}
    }
  }
}
`
